module.exports = __webpack_public_path__ + "static/media/hydronomad-5.50edf2af.jpg";